"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrescribeKpi = void 0;
require("./prescribe-kpi.less");
const React = require("react");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const store_1 = require("client/modules/providers/store");
const menu_1 = require("client/components/material/menu");
const material_ui_1 = require("material-ui");
let PrescribeKpi = class PrescribeKpi extends React.Component {
    constructor() {
        super(...arguments);
        this.anchorEl = null;
        this.handleClickUpdateSignature = (event, provider) => {
            store_1.providersStore.loadActivePads(provider);
            this.anchorEl = event.currentTarget;
        };
        this.handlePadSelectProvider = async (pad, provider) => {
            await store_1.providersStore.promptSignature(pad, provider);
            this.anchorEl = null;
            const signature = provider.signature;
            this.signatureInterval = window.setInterval(async () => {
                const providerUpdate = await store_1.providersStore.readProvider(provider.id);
                if (providerUpdate && signature !== provider.signature) {
                    await store_1.providersStore.loadProviders();
                    provider.signature = providerUpdate.signature;
                    window.clearInterval(this.signatureInterval);
                }
            }, 2500);
        };
        this.render = () => {
            var _a, _b, _c, _d, _e, _f, _g;
            const { prescribeKpi = {
                complete: 0,
                provider: null,
                remaining: 0,
                siteName: ""
            } } = this.props;
            const provider = prescribeKpi.provider;
            return (React.createElement("div", { className: "prescribe-kpi", style: {
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    alignItems: "center"
                } },
                React.createElement(kpi_title_1.KpiTitle, { label: prescribeKpi.siteName, subLabel: `${(_a = provider === null || provider === void 0 ? void 0 : provider.firstName) !== null && _a !== void 0 ? _a : "Administration"} ${(_b = provider === null || provider === void 0 ? void 0 : provider.lastName) !== null && _b !== void 0 ? _b : "View"}`, subLabel2: `Remaining: ${(_d = (_c = prescribeKpi.remaining) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "0"}`, subLabel3: `Completed: ${(_f = (_e = prescribeKpi.complete) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : "0"}` }),
                !!provider && (React.createElement(React.Fragment, null,
                    React.createElement("div", { style: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center"
                        } },
                        React.createElement("p", { style: { color: "#FFF", margin: "0", whiteSpace: "nowrap" } },
                            (provider === null || provider === void 0 ? void 0 : provider.signature) ? "Provider" : "Missing",
                            " Signature"),
                        React.createElement("div", { style: {
                                backgroundColor: "#FFF",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: "1em"
                            } },
                            React.createElement("img", { src: (_g = provider === null || provider === void 0 ? void 0 : provider.signature) !== null && _g !== void 0 ? _g : "", style: { maxHeight: "30px" } }))),
                    React.createElement(button_1.MaterialButton, { onClick: e => this.handleClickUpdateSignature(e, provider), secondary: true, style: { transform: "scale(.8)", whiteSpace: "nowrap", width: "17em" } }, "Update Signature"),
                    React.createElement(menu_1.MaterialMenu, { open: !!this.anchorEl, onClose: () => (this.anchorEl = null), anchorEl: this.anchorEl },
                        (!store_1.providersStore.pads.value ||
                            store_1.providersStore.pads.value.length === 0) && (React.createElement(material_ui_1.MenuItem, { onClick: e => console.log(e) },
                            React.createElement("a", { className: "pad-create-menu-link", href: "/pad", target: "__blank" }, "Click to create"))),
                        store_1.providersStore.pads.value &&
                            store_1.providersStore.pads.value.map((p, index) => (React.createElement(material_ui_1.MenuItem, { key: index, onClick: () => this.handlePadSelectProvider(p, provider) }, p.name))))))));
        };
    }
};
__decorate([
    mobx_1.observable
], PrescribeKpi.prototype, "anchorEl", void 0);
PrescribeKpi = __decorate([
    mobx_react_1.observer
], PrescribeKpi);
exports.PrescribeKpi = PrescribeKpi;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/prescribe/modules/prescribe-view/components/prescribe-kpi/prescribe-kpi.tsx
// module id = 3835
// module chunks = 0